// modals/MoveModal.js
import React, { useState, useEffect } from 'react';
import { getCustomerStages } from '../utils/customerStages';

const MoveModal = ({ show, customer, customers, onConfirm, onCancel, businessType = 'insurance' }) => {
    const CUSTOMER_STAGES = getCustomerStages(businessType);
    const [targetStage, setTargetStage] = useState('');

    // 모달이 열릴 때마다 선택 초기화
    useEffect(() => {
        if (show) {
            setTargetStage('');
        }
    }, [show]);

    if (!show) return null;

    // 현재 단계 찾기 - customers에서 최신 정보 확인
    let currentStageId = '';
    if (customers && customer?.id) {
        // customers 객체에서 고객이 현재 어느 단계에 있는지 찾기
        for (const [stageId, stageCustomers] of Object.entries(customers)) {
            if (stageCustomers && stageCustomers.some(c => c.id === customer.id)) {
                currentStageId = stageId;
                break;
            }
        }
    }
    // customers에서 찾지 못한 경우 customer 객체의 정보 사용
    if (!currentStageId) {
        currentStageId = customer?.__stageId || customer?.stage || '';
    }
    const currentStage = CUSTOMER_STAGES.find(s => s.id === currentStageId);

    const handleConfirm = () => {
        if (targetStage) {
            onConfirm(targetStage);
            // 단계 이동 모달이 닫힐 때 고객 상세 모달도 닫기
            try {
                window.dispatchEvent(new CustomEvent('closeCustomerOverlay'));
            } catch (e) { }
        }
    };

    const handleCancel = () => {
        setTargetStage('');
        onCancel();
        // 단계 이동 모달이 취소될 때도 고객 상세 모달 닫기
        try {
            window.dispatchEvent(new CustomEvent('closeCustomerOverlay'));
        } catch (e) { }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1003]">
            <div className="bg-white rounded-xl max-w-md w-full p-6">
                <div className="text-center mb-6">
                    <div className="text-4xl mb-3">🔄</div>
                    <h3 className="text-xl font-bold text-gray-800 mb-3">고객 단계 이동</h3>
                    <p className="text-gray-600 mb-3">
                        <strong>{customer?.name}</strong>님을<br />
                        어느 단계로 이동하시겠습니까?
                    </p>
                    {currentStage && (
                        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-gray-100 border border-gray-200">
                            <span className="text-lg">{currentStage.emoji}</span>
                            <span className="text-sm font-medium text-gray-700">현재 단계: {currentStage.title}</span>
                        </div>
                    )}
                </div>

                <div className="mb-6">
                    <select
                        value={targetStage}
                        onChange={(e) => setTargetStage(e.target.value)}
                        className="w-full p-4 border-2 border-gray-300 rounded-xl text-lg focus:border-blue-500 focus:outline-none"
                    >
                        <option value="">단계를 선택하세요</option>
                        {CUSTOMER_STAGES.map(stage => (
                            <option key={stage.id} value={stage.id}>
                                {stage.emoji} {stage.title}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="grid grid-cols-2 gap-3">
                    <button
                        onClick={handleCancel}
                        className="py-3 px-4 bg-gray-200 text-gray-700 rounded-xl font-bold text-lg hover:bg-gray-300"
                    >
                        취소
                    </button>
                    <button
                        onClick={handleConfirm}
                        disabled={!targetStage}
                        className="py-3 px-4 bg-purple-500 text-white rounded-xl font-bold text-lg hover:bg-purple-600 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        이동
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MoveModal;